<template>
    <div class="operational-module-wrap">
        <div class="data-row">
            <div class="tagContent">
                <el-tooltip v-if="operationalData.autoData == 'true'" popper-class="orange-tag-tooltip" effect="light"
                    content="每天以数据统计数据更新" placement="top">
                    <span class="tag">自动</span>
                </el-tooltip>
                <el-tooltip v-if="!operationalData.autoData == 'false'" popper-class="blue-tag-tooltip" effect="light"
                    content="运营数据手动更新" placement="top">
                    <span class="tag spic">手动</span>
                </el-tooltip>
            </div>
            <template v-for=" item in operationalDataMap">
                <div class="numCountRow-item" v-if="JudgeEmptyKey(operationalData[item.key])">
                    <div class="numCountRow-item">
                        <span>{{ item.text }}</span>
                        <template v-if="item.key == 'publishCount30D' || item.key == 'soldQuantity30D' || item.key == 'deliverRate48H'">
                            <span class="item-spic">{{ specialFieldDisplay(operationalData[item.key]) }}{{ item.unit }}</span>
                        </template>
                        <template v-else>
                            <span>{{ operationalData[item.key] }}{{ item.unit }}</span>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    props: {
        operationalData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data () {
        return {
            operationalDataMap: [
                {
                    text: '月铺货量:',
                    key: 'publishCount30D',
                    unit: '',
                },
                {
                    text: '24h支付揽收率:',
                    key: 'deliverRate48H',
                    unit: '%',
                },
                {
                    text: '售后率:',
                    key: 'afterSalesRate',
                    unit: '%',
                },
                {
                    text: '月销量:',
                    key: 'soldQuantity30D',
                    unit: '',
                },
            ],
        };
    },
    methods: {
        /**
         * 判断是否为空值
         * @param {*} obj 
         * @returns 
         */
        JudgeEmptyKey (v) {
            return !(_.isNull(v) || _.isUndefined(v) || (_.isObjectLike(v) && _.isEmpty(v)));
        },
        /**
         * 特殊字段显示
         * @param {*} obj 
         * @returns 
         */
        specialFieldDisplay (value) {
            let text = 0;
            if (value >= 0 && value < 100) {
                text = value
            } else if (value >= 100 && value < 10000) {
                text = `${ Math.floor(value / 100) }00+`;
            } else if (value >= 10000) {
                text = `${ (Math.floor(value * 10 / 10000) / 10).toFixed(1) }万+`;
            }
            return text;
        }
    }
};
</script>

<style lang="scss" scoped>
.operational-module-wrap {
    padding-bottom: 10px;

    .data-row {
        display: flex;

        .numCountRow-item {
            display: flex;
            font-size: 14px;
            margin-right: 30px;

            .item-spic {
                color: #fe904f;
            }
        }

        .tagContent {
            margin-right: 20px;

            .tag {
                border-radius: 2px;
                cursor: pointer;
                padding: 2px;
                color: #fff;
                background: #396CF3;
                &.spic{
                    background: #2695FA;
                }
            }
        }
    }
}
</style>